/**
 * Builds a user object for auth state from impersonation target data.
 * Used when starting impersonation and when hydrating from storage.
 *
 * IMPORTANT: This uses the target's actual roles and permissions so the admin
 * sees the same UI/navigation the target would see. This is critical for support
 * to reproduce what the target can access.
 */
export function buildImpersonationUser(target: {
  id: string;
  email: string;
  name: string;
  orgId: string;
  givenName?: string;
  familyName?: string;
  roles?: string[];
  permissions?: string[];
}) {
  return {
    id: target.id,
    email: target.email,
    // Use provided names if available, fall back to parsing display name
    given_name: target.givenName || target.name.split(' ')[0] || '',
    family_name: target.familyName || target.name.split(' ').slice(1).join(' ') || '',
    organization_id: target.orgId,
    // Use target's actual roles/permissions so admin sees the same UI they would
    roles: target.roles ?? ['coach'],
    permissions: target.permissions ?? ['coach:tools'],
  };
}
